import { useQuery } from 'react-query';

import { getQuestions } from 'App/services/AssessmentQuestionService';

function useFetchAssessmentQuestions(assessmentId) {
    return useQuery(['assessmentId', assessmentId, 'questions'], () => getQuestions(assessmentId), {
        retry: false,
        refetchInterval: false,
        refetchOnWindowFocus: false,
    });
}

export default useFetchAssessmentQuestions;
